export default {
  inAMeeting: 'In a meeting',
  onMyWay: 'On my way',
  callMeBackIn: 'Call me back in...',
  willCallYouBackIn: 'Will call you back in...',
  hour: 'hour',
  min: 'min',
} as const;
